import { useRoutes } from 'react-router-dom';

// routes
// import MainRoutes from './MainRoutes';
// import AuthenticationRoutes from './AuthenticationRoutes';
import PublicRoute from './PublicRoute';
import AdminRoute from './AdminRoutes';
import ClientRoutes from './ClientRoutes';
import ProfileRoutes from './ProfileRoutes';
import OtherLoginRoutes from './OtherLoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([PublicRoute, ProfileRoutes, OtherLoginRoutes, AdminRoute, ClientRoutes]);
}
